import styled from 'styled-components'
import LoaderBase from 'react-loader-spinner'
import { IconCheck as IconCheckBase } from '@loadsmart/icons'
import { Checkbox as CheckboxBase } from 'components/Input'

import BaseButton from 'components/Button'

export const LabelP = styled.p`
  && {
    margin-bottom: 5px;
  }
`

export const Loader = styled(LoaderBase)`
  svg {
    display: block;
    margin: 10px auto;
  }
`

export const Button = styled(BaseButton)`
  align-items: center;
  display: flex;
  justify-content: space-evenly;
  margin: 0 auto;
  width: 60px;
`

export const IconCheck = styled(IconCheckBase)`
  color: ${({ theme }) => theme.colors.main};
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;
`

export const Checkbox = styled(CheckboxBase)`
  margin-right: 5px;
`
